import {Component, signal, ChangeDetectionStrategy} from "@angular/core"
import {BaseInspectorComponent} from "@app/template-editor/components/inspectors/base-inspector/base-inspector.component"
import {InspectorSectionComponent} from "@app/template-editor/components/inspectors/inspector-section/inspector-section.component"
import {ValueSlotComponent} from "@app/template-editor/components/value-slot/value-slot.component"
import {ConfigVariant, isValidExternalId} from "@cm/template-nodes"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-config-variant-inspector",
    templateUrl: "./config-variant-inspector.component.html",
    styleUrl: "./config-variant-inspector.component.scss",
    imports: [InspectorSectionComponent, ValueSlotComponent],
})
export class ConfigVariantInspectorComponent extends BaseInspectorComponent<ConfigVariant> {
    readonly $isValidExternalId = signal(isValidExternalId)
}
